import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bda4096&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "../assets/scss/grid.scss?vue&type=style&index=0&module=styleGrid&lang=scss&"
import style1 from "../assets/scss/spacer.scss?vue&type=style&index=1&module=styleSpacer&lang=scss&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&module=true&"
import style3 from "../assets/scss/typography.scss?vue&type=style&index=3&lang=scss&module=styleTypography&"




function injectStyles (context) {
  
  this["styleGrid"] = (style0.locals || style0)
this["styleSpacer"] = (style1.locals || style1)
this["$style"] = (style2.locals || style2)
this["styleTypography"] = (style3.locals || style3)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports